import React, { useRef, useEffect, useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import './BottomPopup.scss';

const BottomPopup = React.forwardRef(({isTopicSelected, linkTo, linkLabel, darkMode }, theRef) => {
  const menuOpened = useSelector(state => state.data.menuOpened);
  const mainElement = useRef(null);
  const fixedMeasurerElement = useRef(null);
  const [popupActive, setPopupActive] = useState(false);

  const handleScroll = () => {
    if (mainElement && mainElement.current && fixedMeasurerElement && fixedMeasurerElement.current){
      const rect = mainElement.current.getBoundingClientRect();
      const measureRect = fixedMeasurerElement.current.getBoundingClientRect();
      if ((rect.y <= measureRect.y + measureRect.height)) {
        setPopupActive(true);
      }
      else if ((rect.y > measureRect.y + measureRect.height)) {
        setPopupActive(false);
      }
    }
  };

  useEffect(() => {
    let supportsPassive = false;
    try {
      window.addEventListener(
        'test',
        null,
        Object.defineProperty({}, 'passive', {
          get: function () {
            supportsPassive = true;
          },
        })
      );
    } catch (e) {}
    const wheelOpt = supportsPassive ? { passive: false } : false;
    const wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';
    
    document.body.addEventListener(wheelEvent, handleScroll, wheelOpt);
    document.body.addEventListener('scroll', handleScroll);

    return () => {
      document.body.removeEventListener('scroll', handleScroll);
      document.body.removeEventListener(wheelEvent, handleScroll, wheelOpt);
    };

  }, []);

  return (
    <div className={`innovation-bottom-popup ${popupActive ? 'active' : ''} ${darkMode ? 'dark-mode' : ''}`} aria-hidden={!popupActive ? "true" : "false"} ref={mainElement}>
      <div className="innovation-bp-fixed-measurer" ref={fixedMeasurerElement}/>
      <div className="innovation-bp-strip-wrapper">
        <div className="innovation-bp-full-content">
          <div className="innovation-bp-content-inner">
            <div className="cpvi-grid-container">
              <div className="cpvi-grid-row">
                <div className="cpvi-grid-col w12">
                  <Link className={`innovation-button ${darkMode ? 'dark-mode' : ''}`} tabIndex={!menuOpened ? !isTopicSelected ? 0 : -1 : -1} to={linkTo}>{linkLabel}</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default BottomPopup;